import { Drawer, Flex, Table, Typography } from 'antd';
import { IDocumentTemplate } from 'interfaces/documentation/document-template';
import { TagField } from '@refinedev/antd';
import { formatDate } from 'services/date';
import { useList } from '@refinedev/core';

interface HistoryDrawerProps {
  template?: IDocumentTemplate;
  open: boolean;
  onClose: () => void;
}

interface ITemplateVersion {
  event: string;
  author: { id: string; name: string } | '';
  author_type: string | null;
  required: [boolean | null, boolean | null] | null;
  created_at: string;
}

const label = (value: boolean | null) => {
  if (value === null || value === undefined) {
    return '—';
  }

  return value ? 'Obrigatório' : 'Opcional';
};

export const HistoryDrawer = ({
  template,
  open,
  onClose
}: HistoryDrawerProps) => {
  const { data, isLoading } = useList<ITemplateVersion>({
    resource: `documents/templates/${template?.id}/logs`,
    queryOptions: { enabled: Boolean(template?.id) && open }
  });

  return (
    <Drawer
      open={open}
      onClose={onClose}
      width={720}
      title={
        <Flex vertical>
          <Typography.Title level={4} className="!mb-0">
            Histórico de alterações
          </Typography.Title>
          <Typography.Text type="secondary" className="font-normal">
            {template?.name}
          </Typography.Text>
        </Flex>
      }
    >
      <Table rowKey="created_at" dataSource={data?.data} loading={isLoading}>
        <Table.Column
          title="Quando"
          dataIndex="created_at"
          key="created_at"
          render={value => formatDate(value)}
        />
        <Table.Column
          title="Quem"
          dataIndex="author"
          key="author"
          // Version sem autor (migration, console) vem como string vazia.
          render={(value: ITemplateVersion['author']) =>
            value && typeof value === 'object' ? value.name : 'Sistema'
          }
        />
        <Table.Column
          title="Obrigatoriedade"
          dataIndex="required"
          key="required"
          render={(value: ITemplateVersion['required']) =>
            value ? (
              <TagField
                value={`${label(value[0])} → ${label(value[1])}`}
                color={value[1] ? 'warning' : 'default'}
              />
            ) : (
              '—'
            )
          }
        />
      </Table>
    </Drawer>
  );
};

export default HistoryDrawer;
